import * as Actions from '../../actions/fuse/index'
import navigationConfig from 'app/fuse-configs/navigationConfig'
import * as R from 'ramda'
import { determineAccess } from 'app/auth/accessControlService'

const initialState = navigationConfig

const navigation = function (state = initialState, action) {
  switch (action.type) {
    case Actions.GET_NAVIGATION: {
      return [...state]
    }
    case Actions.SET_NAVIGATION: {
      return [...action.navigation]
    }
    case Actions.RESET_NAVIGATION: {
      return [...initialState]
    }
    case Actions.UPDATE_NAVIGATION_ACCESS_CONTROL: {
      const navigations = R.reduce(
        (acc, group) => {
          if (
            ['send-message-button', 'chat-manager-web'].includes(group.type)
          ) {
            return [...acc, group]
          } else
            return R.compose(
              R.ifElse(
                R.propSatisfies(R.isEmpty, 'children'),
                R.always(acc),
                R.flip(R.append)(acc),
              ),
              R.over(
                R.lensProp('children'),
                R.filter(
                  (navigation) =>
                    determineAccess(action.permissionInfo, navigation.accesses)
                      .isGranted,
                ),
              ),
            )(group)
        },
        [],
        state,
      )

      return navigations
    }
    default: {
      return state
    }
  }
}

export default navigation
